import * as React from 'react';
import cx from 'classnames';

import './Ellipsis.styles.scss';

export class Ellipsis extends React.Component {
	static defaultProps = {
		withTooltip: true,
	};

	render() {
		const { children, text, withTooltip, width, maxWidth = '100%', className, ...otherProps } = this.props;

		return (
			<div 
				title={withTooltip ? text || children : ''}
				style={{ width, maxWidth }} 
				className={cx('Ellipsis', className)} 
				{...otherProps}
			>
				{text || children}
			</div>
		);
	}
}